import { NgModule } from "@angular/core";
import { UiIconModule } from "../icon/icon.module";
import { UiExternalLinkComponent } from "./external-link.component";

@NgModule({
  imports: [UiIconModule],
  declarations: [UiExternalLinkComponent],
  exports: [UiExternalLinkComponent],
})
export class UiLinkModule {}
